module.exports = __webpack_public_path__ + "img/HC2023-02.1f335967.jpg";